module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isPc()) ? _c('div', [_c('FzgJoinPc')], 1) : _c('div', [_c('FzgJoinMobile')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ca45bfa0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/join/FzgJoin.vue
// module id = 242
// module chunks = 0